import { DisruptionAlert } from "@/pages/rollshop/models/RollshopNotification";
import {
	WarningAmber as DiameterIcon,
	SwapVert as PositionIcon,
	Build as RollIcon,
} from "@mui/icons-material";
import { alpha, Box, Typography } from "@mui/material";

type AlertConfig = {
	icon: React.ElementType;
	color: string;
	bgColor: string;
	label: string;
};

const alertConfig: Record<string, AlertConfig> = {
	D: {
		icon: DiameterIcon,
		color: "#dc2626",
		bgColor: "#fef2f2",
		label: "Diameter",
	},
	P: {
		icon: PositionIcon,
		color: "#d97706",
		bgColor: "#fffbeb",
		label: "Position",
	},
	R: {
		icon: RollIcon,
		color: "#7c3aed",
		bgColor: "#f5f3ff",
		label: "Roll",
	},
};

export const AlertItem = ({ alert }: { alert: DisruptionAlert }) => {
	const config = alertConfig[alert.AlertTypeCode] || {
		icon: DiameterIcon,
		color: "#6b7280",
		bgColor: "#f9fafb",
		label: "Alert",
	};
	const Icon = config.icon;

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1.5,
				p: 1.25,
				borderRadius: 1.5,
				backgroundColor: config.bgColor,
				borderLeft: `3px solid ${config.color}`,
			}}
		>
			<Box
				sx={{
					width: 28,
					height: 28,
					borderRadius: "50%",
					backgroundColor: alpha(config.color, 0.1),
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					flexShrink: 0,
				}}
			>
				<Icon sx={{ fontSize: 14, color: config.color }} />
			</Box>
			<Typography
				variant="body2"
				sx={{ color: "text.primary", fontSize: "0.8rem", lineHeight: 1.4 }}
			>
				{alert.AlertMessage}
			</Typography>
		</Box>
	);
};
